import React from 'react'
import { WorkPeriodWithSummary } from '../../../api/work-periods'
import { Element } from 'react-bulma-components'
import { formatTime, formatDuration } from '../../../utils/date'

interface WorkPeriodSummaryBreaksTooltipProps {
  workPeriod: WorkPeriodWithSummary
}

export const WorkPeriodSummaryBreaksTooltipContent: React.FC<
  WorkPeriodSummaryBreaksTooltipProps
> = ({ workPeriod }) => {
  const items = []

  if (workPeriod.manualBreak) {
    items.push({
      label: 'Pause forcée',
      value: formatDuration(workPeriod.summary.durations.breaks),
    })
  } else if (workPeriod.summary.breaks.length > 0) {
    workPeriod.summary.breaks.forEach((break_, index) => {
      items.push(
        {
          label: `Début pause ${index + 1}`,
          value: formatTime(break_.start),
        },
        {
          label: `Fin pause ${index + 1}`,
          value: formatTime(break_.end),
        },
        {
          label: `Durée pause ${index + 1}`,
          value: formatDuration(break_.duration),
        },
      )
    })
  } else {
    return <Element>Aucune pause</Element>
  }

  return (
    <>
      {items.map(item => (
        <Element key={item.label} style={{ display: 'table-row' }}>
          <Element style={{ display: 'table-cell' }} px={1}>
            {item.label}
          </Element>
          <Element style={{ display: 'table-cell' }} px={1}>
            {item.value}
          </Element>
        </Element>
      ))}
    </>
  )
}
